module.exports = __webpack_public_path__ + "img/tws10.a6e6a3e3.png";